// extracted by mini-css-extract-plugin
export var header = "header-module--header--2K2b3";
export var headerHidden = "header-module--header-hidden--1GoqZ";
export var headerBackground = "header-module--header-background--1-Uk1";
export var headerInner = "header-module--header-inner--3YOc0";
export var brand = "header-module--brand--3DUU3";